<template>
  <div
    id="app"
    @touchstart.stop="handleTouchStart"
    @touchend.stop="handleTouchEnd"
    :class="{ width: this.show }"
  >
    <router-view :showpc="show" class="handleBox"></router-view>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      juli: 0,
      start: 0,
      end: 0,
      title: "111",
      shuaxin: 0,
      show: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleTouchStart(e) {
      this.start = e.touches[0].clientX;
      // console.log(e.touches[0].clientX);
    },
    handleTouchEnd(e) {
      // console.log(e);
      this.end = e.changedTouches[0].clientX;
      if (this.end - this.start > 200) {
        if (this.$route.path.includes("/examination/")) {
          // console.log(5432);
          e.preventDefalut();
        } else {
          this.$router.go(-1);
        }
      }
    },
    handleTouchMove(e) {
      // console.log(this.end);
    },
    onSwipeLeft(e) {
      console.log(
        this.end - this.start,
        this.$route.path,
        this.$route.path.includes("/examination/")
      );

      //
    },
    setRem() {
      console.log(11);
    },
    setRems() {
      console.log(111);
    }
  },
  created() {
    this.$Http.get("/slideShow/?slideShowModel=wx_title").then(res => {
      if (res.data.code == 200) {
        if (res.data.data.content.length !== 0) {
          document.title = res.data.data.content[0].slideShowUrl;
        }
      } else {
        this.$message.error(res.data.message);
      }
    });
  },
  mounted() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // if (location.href.indexOf("#reloaded") == -1) {
      //   location.href = location.href + "#reloaded";

      //   location.reload();
      // }
      document.getElementsByTagName("html")[0].style.fontSize = 37.5 + "px";
      this.show = false;
    } else {
      // debugger;

      this.show = true;
      document.getElementsByTagName("html")[0].style.fontSize = 30 + "px";
      console.log(
        11113221112,
        location.href,
        location.href.indexOf("#reloaded")
      );
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      }
    }
    console.log(this.show);
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  font-size: 0.4rem;
}
.handleBox{
  height: 100%;
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
.width {
  width: 400px;

  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

#app{
  background-color: #F8F8F8;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue